// NATIVE 
import React from 'react';


// INSTALLED 
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { styled } from '@mui/material/styles';


// CUSTOM 
import InputField from '../../formFields/InputField';
import CheckboxField from '../../formFields/checkBoxField';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';





/**
 * EditCargo component is used to edit the details of a cargo.
 * It utilizes Formik for form handling and Redux for state management.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} The rendered EditCargo component.
 * 
 * @component
 * 
 * @example
 * // Example usage of EditCargo component
 * <EditCargo formField={formField} />
 * 
 * @remarks
 * This component uses several hooks:
 * - `useFormikContext` to access Formik context.
 * - `useState` to manage local state for areas_select and dataArea.
 * - `useSelector` to access Redux state for areas and cargos.
 * - `useEffect` to handle side effects such as setting areas_select and dataArea.
 * 
 * The component renders a form with various input fields and checkboxes
 * based on the provided formField props and the current state.
 * 
 * @see {@link https://formik.org/docs/api/useFormikContext} for more information on Formik context.
 * @see {@link https://react-redux.js.org/api/hooks#useselector} for more information on Redux useSelector hook.
 */
export const EditCargo = (props:any) => {


    // USE FORMIK CONTEXT 
    const formikProps:any = useFormikContext();
  

    // USE STATE 
    const [areas_select, setAreasSelect] = React.useState([]);
    const  [dataArea, setDataArea] = React.useState<any>(null);

    // USE SELECTOR 
    const { area, areas_list }:any  = useSelector( (state:any) => state.areas );
    const { cargo }:any  = useSelector( (state:any) => state.cargos );
    

    // FORM FIELDS 
    const { formField: {
        e_name,
        e_description,
        e_area,
        e_visita_domiciliaria,
        e_prueba_psicotecnica,
        e_examen_alimentos,
        e_examen_alturas,
        e_certificado_laboral,
        e_certificado_estudios,
        e_adres,
        e_antecedentes_judicial,
        e_entrevista,
        e_sociodemografica,
        e_dme,
        e_sst,
      }
    } = props;


    // USE EFFECT 
    React.useEffect(() => {

        const areas:any = [];
 
        for (let index = 0; index < areas_list.length; index++) {
            
            const data = {
               label: areas_list[index].name,
               value: areas_list[index].id
            }
            areas.push(data);
         
        }
        setAreasSelect(areas);
 
     }, [areas_list]);



    React.useEffect(() => {
        setDataArea(area);
    }, [area])


    React.useEffect(() => {
        setData(cargo);
    }, [cargo]);


    // CONST STYLE 
    const Div = styled('div')(({ theme }) => ({
        ...theme.typography.button,
        backgroundColor: 'wheat',
        padding: theme.spacing(8),
        textAlign: 'center'
    }));


 
    // CONST FUNCTION 
    const setData = (cargo:any) => {
   
   

      let cargoFormated:any = {};
      cargoFormated.value    = cargo.area.id;
      cargoFormated.label    = cargo.area.name;



        // ID CARGO 
      formikProps.setFieldValue('cargoId', cargo.id );

      // DATOS BASICOS
      formikProps.setFieldValue('e_name', cargo.name );
      formikProps.setFieldValue('e_description',  cargo.description );
      formikProps.setFieldValue('e_area', cargoFormated);
      formikProps.setFieldValue('e_visita_domiciliaria', cargo.visita_domiciliaria);
      formikProps.setFieldValue('e_prueba_psicotecnica', cargo.prueba_psicotecnica);
      formikProps.setFieldValue('e_examen_alimentos', cargo.examen_alimentos);
      formikProps.setFieldValue('e_examen_alturas', cargo.examen_alturas);
      formikProps.setFieldValue('e_certificado_laboral', cargo.certificado_laboral);
      formikProps.setFieldValue('e_certificado_estudios', cargo.certificado_estudios);
      formikProps.setFieldValue('e_adres', cargo.adres);
      formikProps.setFieldValue('e_antecedentes_judicial', cargo.antecedentes_judicial);
      formikProps.setFieldValue('e_entrevista', cargo.entrevista);
      formikProps.setFieldValue('e_sociodemografica', cargo.sociodemografica);
      formikProps.setFieldValue('e_dme', cargo.dme);
      formikProps.setFieldValue('e_sst', cargo.sst);

    }


  return (
    <div>
        
        {
            dataArea &&  
              <div>
                 <Grid>
                    <Grid item xs={12} sx={{ padding: 2 }}>
                        <InputField 
                            name={e_name.name}
                            label={e_name.label}
                            variant="outlined" 
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid  >
                    <Grid item xs={12} sx={{ padding: 2 }}>
                        <TextAreaField 
                            name={e_description.name}
                            label={e_description.label}
                            variant="outlined" 
                            fullWidth
                        />
                    </Grid>
                </Grid>
                {
                    areas_select.length > 0

                    ?
                            <Grid item xs={12} sx={{ padding: 2 }}>
                                    <AutocompleteField  
                                        options={areas_select}
                                        name={e_area.name}
                                        label={e_area.label}
                                        element={area.name}
                                    />
                                    
                            </Grid>
                    :

                    <Div>{"No hay areas disponibles..."}</Div>
                }


                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <CheckboxField  name={e_visita_domiciliaria.name} checked={ dataArea.e_visita_domiciliaria ? true : false } label={e_visita_domiciliaria.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_prueba_psicotecnica.name} checked={ dataArea.e_prueba_psicotecnica ? true : false } label={e_prueba_psicotecnica.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_examen_alimentos.name} checked={ dataArea.e_examen_alimentos ? true : false } label={e_examen_alimentos.label}/>
                        </div>
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <CheckboxField  name={e_examen_alturas.name} checked={ dataArea.e_examen_alturas ? true : false } label={e_examen_alturas.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_certificado_laboral.name} checked={ dataArea.e_certificado_laboral ? true : false } label={e_certificado_laboral.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_certificado_estudios.name} checked={ dataArea.e_certificado_estudios ? true : false } label={e_certificado_estudios.label}/>
                        </div>
                    </Grid>
                </Grid>


                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <CheckboxField  name={e_adres.name} checked={ dataArea.e_adres ? true : false } label={e_adres.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_antecedentes_judicial.name} checked={ dataArea.e_antecedentes_judicial ? true : false } label={e_antecedentes_judicial.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_entrevista.name} checked={ dataArea.e_entrevista ? true : false } label={e_entrevista.label}/>
                        </div>
                    </Grid>
                </Grid>


                <Grid container spacing={2} sx={{ padding: 2 }}>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                        <CheckboxField  name={e_sociodemografica.name} checked={ dataArea.e_sociodemografica ? true : false } label={e_sociodemografica.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_dme.name} checked={ dataArea.e_dme ? true : false } label={e_dme.label}/>
                        </div>
                    </Grid>
                    <Grid item xs={4} sx={{ padding: 2 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                            <CheckboxField  name={e_sst.name} checked={ dataArea.e_sst ? true : false } label={e_sst.label}/>
                        </div>
                    </Grid>
                </Grid>


              </div>
        }
    </div>
  )
}
